import { InjectionToken, Directive, Host, NgModule, SimpleChange, ChangeDetectorRef, Injectable, KeyValueDiffers, ComponentFactoryResolver, Inject, Optional, Input, EventEmitter, Injector, Component, ViewContainerRef, Output, Renderer2, ɵɵdefineInjectable, ɵɵinject, INJECTOR, ElementRef, IterableDiffers } from '@angular/core';
import { NgComponentOutlet, CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/io/types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
function InputsType() { }
/**
 * @record
 */
function OutputsType() { }
/**
 * @record
 */
function OutputWithArgs() { }
if (false) {
    /** @type {?} */
    OutputWithArgs.prototype.handler;
    /** @type {?|undefined} */
    OutputWithArgs.prototype.args;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/io/event-argument.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function defaultEventArgumentFactory() {
    return '$event';
}
/** @type {?} */
const EventArgumentToken = new InjectionToken('EventArgument', {
    providedIn: 'root',
    factory: defaultEventArgumentFactory,
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component-injector/token.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DynamicComponentInjector() { }
if (false) {
    /** @type {?} */
    DynamicComponentInjector.prototype.componentRef;
}
/** @type {?} */
const DynamicComponentInjectorToken = new InjectionToken('DynamicComponentInjector');
/**
 * @deprecated Since v6.0.0 - Use {\@link DynamicComponentInjectorToken} instead
 * and provide component class via `useExisting` instead of `useValue`
 * @type {?}
 */
const COMPONENT_INJECTOR = DynamicComponentInjectorToken;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component-injector/component-outlet-injector.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ComponentOutletInjectorDirective {
    /**
     * @param {?} componentOutlet
     */
    constructor(componentOutlet) {
        this.componentOutlet = componentOutlet;
    }
    /**
     * @return {?}
     */
    get componentRef() {
        // NOTE: Accessing private APIs of Angular
        return ((/** @type {?} */ (this.componentOutlet)))._componentRef;
    }
}
ComponentOutletInjectorDirective.ɵfac = function ComponentOutletInjectorDirective_Factory(t) { return new (t || ComponentOutletInjectorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgComponentOutlet, 1)); };
ComponentOutletInjectorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ComponentOutletInjectorDirective, selectors: [["", "ngComponentOutlet", ""]], exportAs: ["ndcComponentOutletInjector"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: DynamicComponentInjectorToken,
                useExisting: ComponentOutletInjectorDirective
            },
        ])] });
/** @nocollapse */
ComponentOutletInjectorDirective.ctorParameters = () => [
    { type: NgComponentOutlet, decorators: [{ type: Host }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComponentOutletInjectorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[ngComponentOutlet]',
                exportAs: 'ndcComponentOutletInjector',
                providers: [
                    {
                        provide: DynamicComponentInjectorToken,
                        useExisting: ComponentOutletInjectorDirective
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc1.NgComponentOutlet, decorators: [{
                type: Host
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ComponentOutletInjectorDirective.prototype.componentOutlet;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component-injector/component-outlet-injector.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ComponentOutletInjectorModule {
}
ComponentOutletInjectorModule.ɵfac = function ComponentOutletInjectorModule_Factory(t) { return new (t || ComponentOutletInjectorModule)(); };
ComponentOutletInjectorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ComponentOutletInjectorModule });
ComponentOutletInjectorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ComponentOutletInjectorModule, { declarations: function () { return [ComponentOutletInjectorDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ComponentOutletInjectorDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComponentOutletInjectorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [ComponentOutletInjectorDirective],
                declarations: [ComponentOutletInjectorDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component-injector/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/util.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} val
 * @return {?}
 */
function createNewChange(val) {
    return new SimpleChange(undefined, val, true);
}
/**
 * @param {?} val
 * @param {?} prevVal
 * @return {?}
 */
function createChange(val, prevVal) {
    return new SimpleChange(prevVal, val, false);
}
/**
 * @return {?}
 */
function noop() { }
/**
 * @param {?} ctor
 * @param {?} reflect
 * @return {?}
 */
function getCtorParamTypes(ctor, reflect) {
    return reflect.getMetadata('design:paramtypes', ctor);
}
/**
 * Extract type arguments from Angular Directive/Component
 * @param {?} type
 * @return {?}
 */
function extractNgParamTypes(type) {
    var _a, _b, _c;
    // NOTE: Accessing private APIs of Angular
    return (_c = (_b = (_a = ((/** @type {?} */ (type)))) === null || _a === void 0 ? void 0 : _a.ctorParameters) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.map((/**
     * @param {?} param
     * @return {?}
     */
    param => param.type));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/io/io.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IOMapInfo() { }
if (false) {
    /** @type {?} */
    IOMapInfo.prototype.propName;
    /** @type {?} */
    IOMapInfo.prototype.templateName;
}
/**
 * @record
 */
function IoInitOptions() { }
if (false) {
    /** @type {?|undefined} */
    IoInitOptions.prototype.trackOutputChanges;
}
/**
 * @record
 */
function OutputsTypeProcessed() { }
class IoService {
    /**
     * @param {?} differs
     * @param {?} cfr
     * @param {?} eventArgument
     * @param {?} cdr
     */
    constructor(differs, cfr, eventArgument, cdr) {
        this.differs = differs;
        this.cfr = cfr;
        this.eventArgument = eventArgument;
        this.cdr = cdr;
        this.checkInit = this.failInit;
        this.lastComponentInst = null;
        this.inputsDiffer = this.differs.find({}).create();
        this.compFactory = null;
        this.outputsShouldDisconnect$ = new Subject();
        this.outputsChanged = (/**
         * @return {?}
         */
        () => false);
    }
    /**
     * @private
     * @return {?}
     */
    get compRef() {
        return this.compInjector.componentRef;
    }
    /**
     * @private
     * @return {?}
     */
    get componentInst() {
        return this.compRef ? this.compRef.instance : null;
    }
    /**
     * @private
     * @return {?}
     */
    get componentInstChanged() {
        if (this.lastComponentInst !== this.componentInst) {
            this.lastComponentInst = this.componentInst;
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * @private
     * @return {?}
     */
    get compCdr() {
        // tslint:disable-next-line: deprecation
        return this.compRef ? this.compRef.injector.get(ChangeDetectorRef) : null;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._disconnectOutputs();
    }
    /**
     * @param {?} componentInjector
     * @param {?=} options
     * @return {?}
     */
    init(componentInjector, options = {}) {
        this.checkInit = componentInjector ? noop : this.failInit;
        this.compInjector = componentInjector;
        if (options.trackOutputChanges) {
            /** @type {?} */
            const outputsDiffer = this.differs.find({}).create();
            this.outputsChanged = (/**
             * @param {?} outputs
             * @return {?}
             */
            outputs => !!outputsDiffer.diff(outputs));
        }
    }
    /**
     * @param {?} inputs
     * @param {?} outputs
     * @param {?} inputsChanged
     * @param {?} outputsChanged
     * @return {?}
     */
    update(inputs, outputs, inputsChanged, outputsChanged) {
        this.checkInit();
        this.updateIO(inputs, outputs);
        /** @type {?} */
        const compChanged = this.componentInstChanged;
        if (compChanged || inputsChanged) {
            /** @type {?} */
            const inputsChanges = this._getInputsChanges();
            if (inputsChanges) {
                this._updateInputChanges(inputsChanges);
            }
            this.updateInputs(compChanged || !this.lastInputChanges);
        }
        if (compChanged || outputsChanged) {
            this.bindOutputs();
        }
    }
    /**
     * @return {?}
     */
    maybeUpdate() {
        this.checkInit();
        if (this.componentInstChanged) {
            this.updateInputs(true);
            this.bindOutputs();
            return;
        }
        if (this.outputsChanged(this.outputs)) {
            this.bindOutputs();
        }
        if (!this.inputs) {
            return;
        }
        /** @type {?} */
        const inputsChanges = this._getInputsChanges();
        if (inputsChanges) {
            /** @type {?} */
            const isNotFirstChange = !!this.lastInputChanges;
            this._updateInputChanges(inputsChanges);
            if (isNotFirstChange) {
                this.updateInputs();
            }
        }
    }
    /**
     * @private
     * @param {?} inputs
     * @param {?} outputs
     * @return {?}
     */
    updateIO(inputs, outputs) {
        this.inputs = inputs;
        this.outputs = outputs;
    }
    /**
     * @private
     * @param {?=} isFirstChange
     * @return {?}
     */
    updateInputs(isFirstChange = false) {
        if (isFirstChange) {
            this._updateCompFactory();
        }
        /** @type {?} */
        const compInst = this.componentInst;
        /** @type {?} */
        let inputs = this.inputs;
        if (!inputs || !compInst) {
            return;
        }
        inputs = this._resolveInputs(inputs);
        Object.keys(inputs).forEach((/**
         * @param {?} p
         * @return {?}
         */
        p => (compInst[p] = inputs[p])));
        // Mark component for check to re-render with new inputs
        if (this.compCdr) {
            this.compCdr.markForCheck();
        }
        this.notifyOnInputChanges(this.lastInputChanges, isFirstChange);
    }
    /**
     * @private
     * @return {?}
     */
    bindOutputs() {
        this._disconnectOutputs();
        /** @type {?} */
        const compInst = this.componentInst;
        /** @type {?} */
        let outputs = this.outputs;
        if (!outputs || !compInst) {
            return;
        }
        outputs = this._resolveOutputs(outputs);
        Object.keys(outputs)
            .filter((/**
         * @param {?} p
         * @return {?}
         */
        p => compInst[p]))
            .forEach((/**
         * @param {?} p
         * @return {?}
         */
        p => compInst[p]
            .pipe(takeUntil(this.outputsShouldDisconnect$))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            this.cdr.markForCheck();
            return ((/** @type {?} */ (outputs[p])))(event);
        }))));
    }
    /**
     * @private
     * @param {?=} changes
     * @param {?=} forceFirstChanges
     * @return {?}
     */
    notifyOnInputChanges(changes = {}, forceFirstChanges) {
        // Exit early if component not interested to receive changes
        if (!this.componentInst.ngOnChanges) {
            return;
        }
        if (forceFirstChanges) {
            changes = this._collectFirstChanges();
        }
        this.componentInst.ngOnChanges(changes);
    }
    /**
     * @private
     * @return {?}
     */
    _disconnectOutputs() {
        this.outputsShouldDisconnect$.next();
    }
    /**
     * @private
     * @return {?}
     */
    _getInputsChanges() {
        return this.inputsDiffer.diff(this.inputs);
    }
    /**
     * @private
     * @param {?} differ
     * @return {?}
     */
    _updateInputChanges(differ) {
        this.lastInputChanges = this._collectChangesFromDiffer(differ);
    }
    /**
     * @private
     * @return {?}
     */
    _collectFirstChanges() {
        /** @type {?} */
        const changes = (/** @type {?} */ ({}));
        /** @type {?} */
        const inputs = this.inputs;
        Object.keys(inputs).forEach((/**
         * @param {?} prop
         * @return {?}
         */
        prop => (changes[prop] = createNewChange(inputs[prop]))));
        return this._resolveChanges(changes);
    }
    /**
     * @private
     * @param {?} differ
     * @return {?}
     */
    _collectChangesFromDiffer(differ) {
        /** @type {?} */
        const changes = {};
        differ.forEachAddedItem((/**
         * @param {?} record
         * @return {?}
         */
        record => (changes[record.key] = createNewChange(record.currentValue))));
        differ.forEachChangedItem((/**
         * @param {?} record
         * @return {?}
         */
        record => (changes[record.key] = createChange(record.currentValue, record.previousValue))));
        return this._resolveChanges(changes);
    }
    /**
     * @private
     * @return {?}
     */
    _resolveCompFactory() {
        try {
            try {
                return this.cfr.resolveComponentFactory(this.compRef.componentType);
            }
            catch (e) {
                // Fallback if componentType does not exist (happens on NgComponentOutlet)
                return this.cfr.resolveComponentFactory(this.compRef.instance.constructor);
            }
        }
        catch (e) {
            // Factory not available - bailout
            return null;
        }
    }
    /**
     * @private
     * @return {?}
     */
    _updateCompFactory() {
        this.compFactory = this._resolveCompFactory();
    }
    /**
     * @private
     * @param {?} inputs
     * @return {?}
     */
    _resolveInputs(inputs) {
        if (!this.compFactory) {
            return inputs;
        }
        return this._remapIO(inputs, this.compFactory.inputs);
    }
    /**
     * @private
     * @param {?} outputs
     * @return {?}
     */
    _resolveOutputs(outputs) {
        outputs = this._processOutputs(outputs);
        if (!this.compFactory) {
            return outputs;
        }
        return this._remapIO(outputs, this.compFactory.outputs);
    }
    /**
     * @private
     * @param {?} outputs
     * @return {?}
     */
    _processOutputs(outputs) {
        /** @type {?} */
        const processedOutputs = {};
        Object.keys(outputs).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            /** @type {?} */
            const outputExpr = outputs[key];
            if (typeof outputExpr === 'function') {
                processedOutputs[key] = outputExpr;
            }
            else {
                processedOutputs[key] =
                    outputExpr && this._processOutputArgs(outputExpr);
            }
        }));
        return processedOutputs;
    }
    /**
     * @private
     * @param {?} output
     * @return {?}
     */
    _processOutputArgs(output) {
        const { handler } = output;
        /** @type {?} */
        const args = 'args' in output ? output.args || [] : [this.eventArgument];
        return (/**
         * @param {?} event
         * @return {?}
         */
        event => handler(...args.map((/**
         * @param {?} arg
         * @return {?}
         */
        arg => (arg === this.eventArgument ? event : arg)))));
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    _resolveChanges(changes) {
        if (!this.compFactory) {
            return changes;
        }
        return this._remapIO(changes, this.compFactory.inputs);
    }
    /**
     * @private
     * @template T
     * @param {?} io
     * @param {?} mapping
     * @return {?}
     */
    _remapIO(io, mapping) {
        /** @type {?} */
        const newIO = {};
        Object.keys(io).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            /** @type {?} */
            const newKey = this._findPropByTplInMapping(key, mapping) || key;
            newIO[newKey] = io[key];
        }));
        return (/** @type {?} */ (newIO));
    }
    /**
     * @private
     * @param {?} tplName
     * @param {?} mapping
     * @return {?}
     */
    _findPropByTplInMapping(tplName, mapping) {
        for (const map of mapping) {
            if (map.templateName === tplName) {
                return map.propName;
            }
        }
        return null;
    }
    /**
     * @private
     * @return {?}
     */
    failInit() {
        throw Error('IoService: ComponentInjector was not set! Please call init() method!');
    }
}
IoService.ɵfac = function IoService_Factory(t) { return new (t || IoService)(ɵngcc0.ɵɵinject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(EventArgumentToken), ɵngcc0.ɵɵinject(ɵngcc0.ChangeDetectorRef)); };
IoService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: IoService, factory: IoService.ɵfac });
/** @nocollapse */
IoService.ctorParameters = () => [
    { type: KeyValueDiffers },
    { type: ComponentFactoryResolver },
    { type: String, decorators: [{ type: Inject, args: [EventArgumentToken,] }] },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IoService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc0.ComponentFactoryResolver }, { type: String, decorators: [{
                type: Inject,
                args: [EventArgumentToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.checkInit;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.lastComponentInst;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.lastInputChanges;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.inputsDiffer;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.compFactory;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.outputsShouldDisconnect$;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.inputs;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.outputs;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.compInjector;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.outputsChanged;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.differs;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.cfr;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.eventArgument;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.cdr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/io/io-factory.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IoFactoryService {
    /**
     * @param {?} differs
     * @param {?} cfr
     * @param {?} eventArgument
     * @param {?} cdr
     */
    constructor(differs, cfr, eventArgument, cdr) {
        this.differs = differs;
        this.cfr = cfr;
        this.eventArgument = eventArgument;
        this.cdr = cdr;
    }
    /**
     * @return {?}
     */
    create() {
        return new IoService(this.differs, this.cfr, this.eventArgument, this.cdr);
    }
}
IoFactoryService.ɵfac = function IoFactoryService_Factory(t) { return new (t || IoFactoryService)(ɵngcc0.ɵɵinject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(EventArgumentToken), ɵngcc0.ɵɵinject(ɵngcc0.ChangeDetectorRef)); };
IoFactoryService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: IoFactoryService, factory: IoFactoryService.ɵfac });
/** @nocollapse */
IoFactoryService.ctorParameters = () => [
    { type: KeyValueDiffers },
    { type: ComponentFactoryResolver },
    { type: String, decorators: [{ type: Inject, args: [EventArgumentToken,] }] },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IoFactoryService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc0.ComponentFactoryResolver }, { type: String, decorators: [{
                type: Inject,
                args: [EventArgumentToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    IoFactoryService.prototype.differs;
    /**
     * @type {?}
     * @private
     */
    IoFactoryService.prototype.cfr;
    /**
     * @type {?}
     * @private
     */
    IoFactoryService.prototype.eventArgument;
    /**
     * @type {?}
     * @private
     */
    IoFactoryService.prototype.cdr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/io/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-io/dynamic-io.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line: no-conflicting-lifecycle
class DynamicIoDirective {
    /**
     * @param {?} ioService
     * @param {?=} componentInjector
     */
    constructor(ioService, componentInjector) {
        this.ioService = ioService;
        this.componentInjector = componentInjector;
        this.ioService.init(this.componentInjector);
    }
    /**
     * @private
     * @return {?}
     */
    get inputs() {
        return this.ndcDynamicInputs || this.ngComponentOutletNdcDynamicInputs;
    }
    /**
     * @private
     * @return {?}
     */
    get outputs() {
        return this.ndcDynamicOutputs || this.ngComponentOutletNdcDynamicOutputs;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.ioService.update(this.inputs, this.outputs, this.inputsChanged(changes), this.outputsChanged(changes));
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        this.ioService.maybeUpdate();
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    inputsChanged(changes) {
        return ('ngComponentOutletNdcDynamicInputs' in changes ||
            'ndcDynamicInputs' in changes);
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    outputsChanged(changes) {
        return ('ngComponentOutletNdcDynamicOutputs' in changes ||
            'ndcDynamicOutputs' in changes);
    }
}
DynamicIoDirective.ɵfac = function DynamicIoDirective_Factory(t) { return new (t || DynamicIoDirective)(ɵngcc0.ɵɵdirectiveInject(IoService), ɵngcc0.ɵɵdirectiveInject(DynamicComponentInjectorToken, 8)); };
DynamicIoDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DynamicIoDirective, selectors: [["", "ndcDynamicInputs", ""], ["", "ndcDynamicOutputs", ""], ["", "ngComponentOutletNdcDynamicInputs", ""], ["", "ngComponentOutletNdcDynamicOutputs", ""]], inputs: { ndcDynamicInputs: "ndcDynamicInputs", ngComponentOutletNdcDynamicInputs: "ngComponentOutletNdcDynamicInputs", ndcDynamicOutputs: "ndcDynamicOutputs", ngComponentOutletNdcDynamicOutputs: "ngComponentOutletNdcDynamicOutputs" }, features: [ɵngcc0.ɵɵProvidersFeature([IoService]), ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
DynamicIoDirective.ctorParameters = () => [
    { type: IoService },
    { type: undefined, decorators: [{ type: Inject, args: [DynamicComponentInjectorToken,] }, { type: Optional }] }
];
DynamicIoDirective.propDecorators = {
    ndcDynamicInputs: [{ type: Input }],
    ngComponentOutletNdcDynamicInputs: [{ type: Input }],
    ndcDynamicOutputs: [{ type: Input }],
    ngComponentOutletNdcDynamicOutputs: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicIoDirective, [{
        type: Directive,
        args: [{
                selector: '[ndcDynamicInputs],[ndcDynamicOutputs],[ngComponentOutletNdcDynamicInputs],[ngComponentOutletNdcDynamicOutputs]',
                providers: [IoService]
            }]
    }], function () { return [{ type: IoService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DynamicComponentInjectorToken]
            }, {
                type: Optional
            }] }]; }, { ndcDynamicInputs: [{
            type: Input
        }], ngComponentOutletNdcDynamicInputs: [{
            type: Input
        }], ndcDynamicOutputs: [{
            type: Input
        }], ngComponentOutletNdcDynamicOutputs: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicIoDirective.prototype.ndcDynamicInputs;
    /** @type {?} */
    DynamicIoDirective.prototype.ngComponentOutletNdcDynamicInputs;
    /** @type {?} */
    DynamicIoDirective.prototype.ndcDynamicOutputs;
    /** @type {?} */
    DynamicIoDirective.prototype.ngComponentOutletNdcDynamicOutputs;
    /**
     * @type {?}
     * @private
     */
    DynamicIoDirective.prototype.ioService;
    /**
     * @type {?}
     * @private
     */
    DynamicIoDirective.prototype.componentInjector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-io/dynamic-io.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DynamicIoModule {
}
DynamicIoModule.ɵfac = function DynamicIoModule_Factory(t) { return new (t || DynamicIoModule)(); };
DynamicIoModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DynamicIoModule });
DynamicIoModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule], ComponentOutletInjectorModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicIoModule, { declarations: function () { return [DynamicIoDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DynamicIoDirective, ComponentOutletInjectorModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicIoModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [DynamicIoDirective, ComponentOutletInjectorModule],
                declarations: [DynamicIoDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-io/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DynamicComponent {
    /**
     * @param {?} vcr
     * @param {?} cfr
     */
    constructor(vcr, cfr) {
        this.vcr = vcr;
        this.cfr = cfr;
        this.ndcDynamicCreated = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.ndcDynamicComponent) {
            this.createDynamicComponent();
        }
    }
    /**
     * @return {?}
     */
    createDynamicComponent() {
        this.vcr.clear();
        this.componentRef = null;
        if (this.ndcDynamicComponent) {
            this.componentRef = this.vcr.createComponent(this.cfr.resolveComponentFactory(this.ndcDynamicComponent), 0, this._resolveInjector(), this.ndcDynamicContent);
            this.ndcDynamicCreated.emit(this.componentRef);
        }
    }
    /**
     * @private
     * @return {?}
     */
    _resolveInjector() {
        /** @type {?} */
        let injector = this.ndcDynamicInjector || this.vcr.injector;
        if (this.ndcDynamicProviders) {
            injector = Injector.create({
                providers: this.ndcDynamicProviders,
                parent: injector,
            });
        }
        return injector;
    }
}
DynamicComponent.ɵfac = function DynamicComponent_Factory(t) { return new (t || DynamicComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
DynamicComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DynamicComponent, selectors: [["ndc-dynamic"]], inputs: { ndcDynamicComponent: "ndcDynamicComponent", ndcDynamicInjector: "ndcDynamicInjector", ndcDynamicProviders: "ndcDynamicProviders", ndcDynamicContent: "ndcDynamicContent" }, outputs: { ndcDynamicCreated: "ndcDynamicCreated" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: DynamicComponentInjectorToken, useExisting: DynamicComponent },
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function DynamicComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
DynamicComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
DynamicComponent.propDecorators = {
    ndcDynamicComponent: [{ type: Input }],
    ndcDynamicInjector: [{ type: Input }],
    ndcDynamicProviders: [{ type: Input }],
    ndcDynamicContent: [{ type: Input }],
    ndcDynamicCreated: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicComponent, [{
        type: Component,
        args: [{
                selector: 'ndc-dynamic',
                template: '',
                providers: [
                    { provide: DynamicComponentInjectorToken, useExisting: DynamicComponent },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { ndcDynamicCreated: [{
            type: Output
        }], ndcDynamicComponent: [{
            type: Input
        }], ndcDynamicInjector: [{
            type: Input
        }], ndcDynamicProviders: [{
            type: Input
        }], ndcDynamicContent: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicComponent;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicInjector;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicProviders;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicContent;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicCreated;
    /** @type {?} */
    DynamicComponent.prototype.componentRef;
    /**
     * @type {?}
     * @private
     */
    DynamicComponent.prototype.vcr;
    /**
     * @type {?}
     * @private
     */
    DynamicComponent.prototype.cfr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DynamicModule {
}
DynamicModule.ɵfac = function DynamicModule_Factory(t) { return new (t || DynamicModule)(); };
DynamicModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DynamicModule });
DynamicModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, DynamicIoModule], DynamicIoModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicModule, { declarations: function () { return [DynamicComponent]; }, imports: function () { return [CommonModule, DynamicIoModule]; }, exports: function () { return [DynamicComponent, DynamicIoModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, DynamicIoModule],
                exports: [DynamicComponent, DynamicIoModule],
                declarations: [DynamicComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-attributes/dynamic-attributes.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AttributesMap() { }
/**
 * @record
 */
function AttributeActions() { }
if (false) {
    /** @type {?} */
    AttributeActions.prototype.set;
    /** @type {?} */
    AttributeActions.prototype.remove;
}
class DynamicAttributesDirective {
    /**
     * @param {?} renderer
     * @param {?} differs
     * @param {?} injector
     * @param {?=} componentInjector
     */
    constructor(renderer, differs, injector, componentInjector) {
        this.renderer = renderer;
        this.differs = differs;
        this.injector = injector;
        this.componentInjector = componentInjector;
        this.attrsDiffer = this.differs.find({}).create();
    }
    /**
     * @private
     * @return {?}
     */
    get _attributes() {
        return (this.ndcDynamicAttributes || this.ngComponentOutletNdcDynamicAttributes);
    }
    /**
     * @private
     * @return {?}
     */
    get _nativeElement() {
        var _a;
        return (_a = this.componentInjector.componentRef) === null || _a === void 0 ? void 0 : _a.location.nativeElement;
    }
    /**
     * @private
     * @return {?}
     */
    get _compType() {
        var _a;
        return (_a = this.componentInjector.componentRef) === null || _a === void 0 ? void 0 : _a.componentType;
    }
    /**
     * @private
     * @return {?}
     */
    get _isCompChanged() {
        if (this.lastCompType !== this._compType) {
            this.lastCompType = this._compType;
            return true;
        }
        return false;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        /** @type {?} */
        const isCompChanged = this._isCompChanged;
        /** @type {?} */
        const changes = this.attrsDiffer.diff(this._attributes);
        if (changes) {
            this.lastAttrActions = this._changesToAttrActions(changes);
        }
        if (changes || (isCompChanged && this.lastAttrActions)) {
            this._updateAttributes(this.lastAttrActions);
        }
    }
    /**
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    setAttribute(name, value, namespace) {
        if (this._nativeElement) {
            this.renderer.setAttribute(this._nativeElement, name, value, namespace);
        }
    }
    /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    removeAttribute(name, namespace) {
        if (this._nativeElement) {
            this.renderer.removeAttribute(this._nativeElement, name, namespace);
        }
    }
    /**
     * @private
     * @param {?} actions
     * @return {?}
     */
    _updateAttributes(actions) {
        // ? Early exit if no dynamic component
        if (!this._compType) {
            return;
        }
        Object.keys(actions.set).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => this.setAttribute(key, actions.set[key])));
        actions.remove.forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => this.removeAttribute(key)));
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    _changesToAttrActions(changes) {
        /** @type {?} */
        const attrActions = {
            set: {},
            remove: [],
        };
        changes.forEachAddedItem((/**
         * @param {?} r
         * @return {?}
         */
        r => (attrActions.set[r.key] = r.currentValue)));
        changes.forEachChangedItem((/**
         * @param {?} r
         * @return {?}
         */
        r => (attrActions.set[r.key] = r.currentValue)));
        changes.forEachRemovedItem((/**
         * @param {?} r
         * @return {?}
         */
        r => attrActions.remove.push(r.key)));
        return attrActions;
    }
}
DynamicAttributesDirective.ɵfac = function DynamicAttributesDirective_Factory(t) { return new (t || DynamicAttributesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(DynamicComponentInjectorToken, 8)); };
DynamicAttributesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DynamicAttributesDirective, selectors: [["", "ndcDynamicAttributes", ""], ["", "ngComponentOutletNdcDynamicAttributes", ""]], inputs: { ndcDynamicAttributes: "ndcDynamicAttributes", ngComponentOutletNdcDynamicAttributes: "ngComponentOutletNdcDynamicAttributes" }, exportAs: ["ndcDynamicAttributes"] });
/** @nocollapse */
DynamicAttributesDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: KeyValueDiffers },
    { type: Injector },
    { type: undefined, decorators: [{ type: Inject, args: [DynamicComponentInjectorToken,] }, { type: Optional }] }
];
DynamicAttributesDirective.propDecorators = {
    ndcDynamicAttributes: [{ type: Input }],
    ngComponentOutletNdcDynamicAttributes: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicAttributesDirective, [{
        type: Directive,
        args: [{
                selector: '[ndcDynamicAttributes],[ngComponentOutletNdcDynamicAttributes]',
                exportAs: 'ndcDynamicAttributes'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc0.Injector }, { type: undefined, decorators: [{
                type: Inject,
                args: [DynamicComponentInjectorToken]
            }, {
                type: Optional
            }] }]; }, { ndcDynamicAttributes: [{
            type: Input
        }], ngComponentOutletNdcDynamicAttributes: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicAttributesDirective.prototype.ndcDynamicAttributes;
    /** @type {?} */
    DynamicAttributesDirective.prototype.ngComponentOutletNdcDynamicAttributes;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.attrsDiffer;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.lastCompType;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.lastAttrActions;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.differs;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.componentInjector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-attributes/dynamic-attributes.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DynamicAttributesModule {
}
DynamicAttributesModule.ɵfac = function DynamicAttributesModule_Factory(t) { return new (t || DynamicAttributesModule)(); };
DynamicAttributesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DynamicAttributesModule });
DynamicAttributesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule], ComponentOutletInjectorModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicAttributesModule, { declarations: function () { return [DynamicAttributesDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DynamicAttributesDirective, ComponentOutletInjectorModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicAttributesModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [DynamicAttributesDirective, ComponentOutletInjectorModule],
                declarations: [DynamicAttributesDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-attributes/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/window-ref/window-ref-browser.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function browserWindowFactory() {
    return window;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/window-ref/window-ref.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const WindowRefToken = new InjectionToken('WindowRef', {
    providedIn: 'root',
    factory: browserWindowFactory,
});
class WindowRefService {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        this.injector = injector;
        this.nativeWindow = this.injector.get(WindowRefToken, null);
    }
}
WindowRefService.ɵfac = function WindowRefService_Factory(t) { return new (t || WindowRefService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
/** @nocollapse */
WindowRefService.ctorParameters = () => [
    { type: Injector }
];
/** @nocollapse */ WindowRefService.ɵprov = ɵɵdefineInjectable({ factory: function WindowRefService_Factory() { return new WindowRefService(ɵɵinject(INJECTOR)); }, token: WindowRefService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WindowRefService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();
if (false) {
    /** @type {?} */
    WindowRefService.prototype.nativeWindow;
    /**
     * @type {?}
     * @private
     */
    WindowRefService.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/window-ref/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-directives/dynamic-directives.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template T
 */
function DynamicDirectiveDef() { }
if (false) {
    /** @type {?} */
    DynamicDirectiveDef.prototype.type;
    /** @type {?|undefined} */
    DynamicDirectiveDef.prototype.inputs;
    /** @type {?|undefined} */
    DynamicDirectiveDef.prototype.outputs;
}
/**
 * @template T
 * @param {?} type
 * @param {?=} inputs
 * @param {?=} outputs
 * @return {?}
 */
function dynamicDirectiveDef(type, inputs, outputs) {
    return { type, inputs, outputs };
}
/**
 * @record
 * @template T
 */
function DirectiveRef() { }
if (false) {
    /** @type {?} */
    DirectiveRef.prototype.instance;
    /** @type {?} */
    DirectiveRef.prototype.type;
    /** @type {?} */
    DirectiveRef.prototype.injector;
    /** @type {?} */
    DirectiveRef.prototype.hostComponent;
    /** @type {?} */
    DirectiveRef.prototype.hostView;
    /** @type {?} */
    DirectiveRef.prototype.location;
    /** @type {?} */
    DirectiveRef.prototype.changeDetectorRef;
    /** @type {?} */
    DirectiveRef.prototype.onDestroy;
}
class DynamicDirectivesDirective {
    /**
     * @param {?} iterableDiffers
     * @param {?} ioFactoryService
     * @param {?} windowRef
     * @param {?=} componentInjector
     */
    constructor(iterableDiffers, ioFactoryService, windowRef, componentInjector) {
        this.iterableDiffers = iterableDiffers;
        this.ioFactoryService = ioFactoryService;
        this.windowRef = windowRef;
        this.componentInjector = componentInjector;
        this.ndcDynamicDirectivesCreated = new EventEmitter();
        this.dirRef = new Map();
        this.dirIo = new Map();
        this.dirsDiffer = this.iterableDiffers
            .find([])
            .create((/**
         * @param {?} _
         * @param {?} def
         * @return {?}
         */
        (_, def) => def.type));
    }
    /**
     * @private
     * @return {?}
     */
    get directives() {
        return (this.ndcDynamicDirectives || this.ngComponentOutletNdcDynamicDirectives);
    }
    /**
     * @private
     * @return {?}
     */
    get componentRef() {
        return this.componentInjector.componentRef;
    }
    /**
     * @private
     * @return {?}
     */
    get compInstance() {
        return this.componentRef && this.componentRef.instance;
    }
    /**
     * @private
     * @return {?}
     */
    get isCompChanged() {
        if (this.lastCompInstance !== this.compInstance) {
            this.lastCompInstance = this.compInstance;
            return true;
        }
        return false;
    }
    /**
     * @private
     * @return {?}
     */
    get hostInjector() {
        return this.componentRef.injector;
    }
    /**
     * @private
     * @return {?}
     */
    get hostVcr() {
        // NOTE: Accessing private APIs of Angular
        // tslint:disable-next-line: no-string-literal
        return this.componentRef['_viewRef']['_viewContainerRef'];
    }
    /**
     * @private
     * @return {?}
     */
    get reflect() {
        return ((/** @type {?} */ (this.windowRef.nativeWindow))).Reflect;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (this.maybeDestroyDirectives()) {
            return;
        }
        /** @type {?} */
        const dirsChanges = this.dirsDiffer.diff(this.directives);
        if (!dirsChanges) {
            return this.updateDirectives();
        }
        this.processDirChanges(dirsChanges);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroyAllDirectives();
    }
    /**
     * @private
     * @return {?}
     */
    maybeDestroyDirectives() {
        if (this.isCompChanged || !this.componentRef) {
            this.dirsDiffer.diff([]);
            this.destroyAllDirectives();
        }
        return !this.componentRef;
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    processDirChanges(changes) {
        changes.forEachRemovedItem((/**
         * @param {?} __0
         * @return {?}
         */
        ({ item }) => this.destroyDirective(item)));
        /** @type {?} */
        const createdDirs = [];
        changes.forEachAddedItem((/**
         * @param {?} __0
         * @return {?}
         */
        ({ item }) => createdDirs.push(this.initDirective(item))));
        if (createdDirs.length) {
            this.ndcDynamicDirectivesCreated.emit(createdDirs.filter(Boolean));
        }
    }
    /**
     * @private
     * @return {?}
     */
    updateDirectives() {
        this.directives.forEach((/**
         * @param {?} dir
         * @return {?}
         */
        dir => this.updateDirective(dir)));
    }
    /**
     * @private
     * @param {?} dirDef
     * @return {?}
     */
    updateDirective(dirDef) {
        /** @type {?} */
        const io = this.dirIo.get(dirDef.type);
        io.update(dirDef.inputs, dirDef.outputs, false, false);
        io.maybeUpdate();
    }
    /**
     * @private
     * @param {?} dirDef
     * @return {?}
     */
    initDirective(dirDef) {
        if (this.dirRef.has(dirDef.type)) {
            return;
        }
        /** @type {?} */
        const instance = this.createDirective(dirDef.type);
        /** @type {?} */
        const dir = {
            instance,
            type: dirDef.type,
            injector: this.hostInjector,
            hostComponent: this.componentRef.instance,
            hostView: this.componentRef.hostView,
            location: this.componentRef.location,
            changeDetectorRef: this.componentRef.changeDetectorRef,
            onDestroy: this.componentRef.onDestroy,
        };
        this.initDirIO(dir, dirDef.inputs, dirDef.outputs);
        this.callInitHooks(instance);
        this.dirRef.set(dir.type, dir);
        return dir;
    }
    /**
     * @private
     * @return {?}
     */
    destroyAllDirectives() {
        this.dirRef.forEach((/**
         * @param {?} dir
         * @return {?}
         */
        dir => this.destroyDirRef(dir)));
        this.dirRef.clear();
        this.dirIo.clear();
    }
    /**
     * @private
     * @param {?} dirDef
     * @return {?}
     */
    destroyDirective(dirDef) {
        this.destroyDirRef(this.dirRef.get(dirDef.type));
        this.dirRef.delete(dirDef.type);
        this.dirIo.delete(dirDef.type);
    }
    /**
     * @private
     * @param {?} dir
     * @param {?=} inputs
     * @param {?=} outputs
     * @return {?}
     */
    initDirIO(dir, inputs, outputs) {
        /** @type {?} */
        const io = this.ioFactoryService.create();
        io.init({ componentRef: this.dirToCompDef(dir) }, { trackOutputChanges: true });
        io.update(inputs, outputs, !!inputs, !!outputs);
        this.dirIo.set(dir.type, io);
    }
    /**
     * @private
     * @param {?} dir
     * @return {?}
     */
    dirToCompDef(dir) {
        return {
            changeDetectorRef: this.componentRef.changeDetectorRef,
            hostView: this.componentRef.hostView,
            location: this.componentRef.location,
            destroy: this.componentRef.destroy,
            onDestroy: this.componentRef.onDestroy,
            injector: this.componentRef.injector,
            instance: dir.instance,
            componentType: dir.type,
        };
    }
    /**
     * @private
     * @param {?} dir
     * @return {?}
     */
    destroyDirRef(dir) {
        /** @type {?} */
        const io = this.dirIo.get(dir.type);
        io.ngOnDestroy();
        if ('ngOnDestroy' in dir.instance) {
            dir.instance.ngOnDestroy();
        }
    }
    /**
     * @private
     * @template T
     * @param {?} dirType
     * @return {?}
     */
    createDirective(dirType) {
        /** @type {?} */
        const directiveInjector = Injector.create({
            providers: [
                {
                    provide: dirType,
                    useClass: dirType,
                    deps: this.resolveDirParamTypes(dirType),
                },
                { provide: ElementRef, useValue: this.componentRef.location },
            ],
            parent: this.hostInjector,
            name: `DynamicDirectiveInjector:${dirType.name}@${this.componentRef.componentType.name}`,
        });
        return directiveInjector.get(dirType);
    }
    /**
     * @private
     * @param {?} dirType
     * @return {?}
     */
    resolveDirParamTypes(dirType) {
        var _a, _b;
        return ((_b = (_a = 
        // First try Angular Compiler's metadata
        extractNgParamTypes(dirType)) !== null && _a !== void 0 ? _a : 
        // Then fallback to Typescript Reflect API
        getCtorParamTypes(dirType, this.reflect)) !== null && _b !== void 0 ? _b : 
        // Bailout
        []);
    }
    /**
     * @private
     * @param {?} obj
     * @return {?}
     */
    callInitHooks(obj) {
        this.callHook(obj, 'ngOnInit');
        this.callHook(obj, 'ngDoCheck');
        this.callHook(obj, 'ngAfterContentInit');
        this.callHook(obj, 'ngAfterContentChecked');
        this.callHook(obj, 'ngAfterViewInit');
        this.callHook(obj, 'ngAfterViewChecked');
    }
    /**
     * @private
     * @param {?} obj
     * @param {?} hook
     * @param {?=} args
     * @return {?}
     */
    callHook(obj, hook, args = []) {
        if (obj[hook]) {
            obj[hook](...args);
        }
    }
}
DynamicDirectivesDirective.ɵfac = function DynamicDirectivesDirective_Factory(t) { return new (t || DynamicDirectivesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers), ɵngcc0.ɵɵdirectiveInject(IoFactoryService), ɵngcc0.ɵɵdirectiveInject(WindowRefService), ɵngcc0.ɵɵdirectiveInject(DynamicComponentInjectorToken, 8)); };
DynamicDirectivesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DynamicDirectivesDirective, selectors: [["", "ndcDynamicDirectives", ""], ["", "ngComponentOutletNdcDynamicDirectives", ""]], inputs: { ndcDynamicDirectives: "ndcDynamicDirectives", ngComponentOutletNdcDynamicDirectives: "ngComponentOutletNdcDynamicDirectives" }, outputs: { ndcDynamicDirectivesCreated: "ndcDynamicDirectivesCreated" }, features: [ɵngcc0.ɵɵProvidersFeature([IoFactoryService])] });
/** @nocollapse */
DynamicDirectivesDirective.ctorParameters = () => [
    { type: IterableDiffers },
    { type: IoFactoryService },
    { type: WindowRefService },
    { type: undefined, decorators: [{ type: Inject, args: [DynamicComponentInjectorToken,] }, { type: Optional }] }
];
DynamicDirectivesDirective.propDecorators = {
    ndcDynamicDirectives: [{ type: Input }],
    ngComponentOutletNdcDynamicDirectives: [{ type: Input }],
    ndcDynamicDirectivesCreated: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicDirectivesDirective, [{
        type: Directive,
        args: [{
                selector: '[ndcDynamicDirectives],[ngComponentOutletNdcDynamicDirectives]',
                providers: [IoFactoryService]
            }]
    }], function () { return [{ type: ɵngcc0.IterableDiffers }, { type: IoFactoryService }, { type: WindowRefService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DynamicComponentInjectorToken]
            }, {
                type: Optional
            }] }]; }, { ndcDynamicDirectivesCreated: [{
            type: Output
        }], ndcDynamicDirectives: [{
            type: Input
        }], ngComponentOutletNdcDynamicDirectives: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicDirectivesDirective.prototype.ndcDynamicDirectives;
    /** @type {?} */
    DynamicDirectivesDirective.prototype.ngComponentOutletNdcDynamicDirectives;
    /** @type {?} */
    DynamicDirectivesDirective.prototype.ndcDynamicDirectivesCreated;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.lastCompInstance;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.dirRef;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.dirIo;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.dirsDiffer;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.iterableDiffers;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.ioFactoryService;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.windowRef;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.componentInjector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-directives/dynamic-directives.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DynamicDirectivesModule {
}
DynamicDirectivesModule.ɵfac = function DynamicDirectivesModule_Factory(t) { return new (t || DynamicDirectivesModule)(); };
DynamicDirectivesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DynamicDirectivesModule });
DynamicDirectivesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule], ComponentOutletInjectorModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicDirectivesModule, { declarations: function () { return [DynamicDirectivesDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DynamicDirectivesDirective, ComponentOutletInjectorModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicDirectivesModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [DynamicDirectivesDirective, ComponentOutletInjectorModule],
                declarations: [DynamicDirectivesDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-directives/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ng-dynamic-component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { COMPONENT_INJECTOR, ComponentOutletInjectorDirective, ComponentOutletInjectorModule, DynamicAttributesDirective, DynamicAttributesModule, DynamicComponent, DynamicComponentInjectorToken, DynamicDirectivesDirective, DynamicDirectivesModule, DynamicIoDirective, DynamicIoModule, DynamicModule, EventArgumentToken, defaultEventArgumentFactory, dynamicDirectiveDef, DynamicIoModule as ɵa, DynamicComponentInjectorToken as ɵb };

//# sourceMappingURL=ng-dynamic-component.js.map